import React from "react";

import { infoBlockDataIProps } from "~/entity/Ivideon/model/schema";
import { dataContentInfoCardCar } from "~/pages/IvideonDealerSummary2/options";

import InfoItemBlock from "./InfoItemBlock";

interface InfoBlockIProps {
  results: infoBlockDataIProps;
  variant: string | null;
  switcher: boolean;
}

const InfoBlock = ({ results, variant, switcher }: InfoBlockIProps) => {
  return (
    <>
      {dataContentInfoCardCar.map((info) => {
        return (
          <InfoItemBlock
            key={info.value}
            result={results[info.value as keyof infoBlockDataIProps]}
            label={info.label}
            variant={variant}
            switcher={switcher}
            data={JSON.stringify(info)}
          />
        );
      })}
    </>
  );
};

export default InfoBlock;
